module.exports = __webpack_public_path__ + "static/media/1020959.d20fa24c.png";